import { render, staticRenderFns } from "./Coupon.vue?vue&type=template&id=5fe9275c&scoped=true&"
import script from "./Coupon.vue?vue&type=script&lang=js&"
export * from "./Coupon.vue?vue&type=script&lang=js&"
import style0 from "./Coupon.vue?vue&type=style&index=0&id=5fe9275c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe9275c",
  null
  
)

export default component.exports